<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Dashboard Ganado</h1>

    <!-- KPIs -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
      <div class="bg-white rounded-md shadow p-6">
        <div class="text-sm text-gray-500">Total de animales</div>
        <div class="text-3xl font-bold mt-2">{{ total }}</div>
      </div>

      <div class="bg-white rounded-md shadow p-6">
        <div class="text-sm text-gray-500">Especies registradas</div>
        <div class="text-3xl font-bold mt-2">{{ porEspecie.length }}</div>
      </div>

      <div class="bg-white rounded-md shadow p-6">
        <div class="text-sm text-gray-500">Estados registrados</div>
        <div class="text-3xl font-bold mt-2">{{ porEstado.length }}</div>
      </div>
    </div>

    <!-- Tablas -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <!-- Por especie -->
      <div class="bg-white rounded-md shadow overflow-hidden">
        <div class="px-6 py-4 bg-gray-50 border-b border-gray-100 font-bold">
          Animales por especie
        </div>
        <div class="overflow-x-auto">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="px-6 pt-6 pb-4">Especie</th>
              <th class="px-6 pt-6 pb-4">Cantidad</th>
              <th class="px-6 pt-6 pb-4">% del total</th>
            </tr>
            <tr v-for="(e, i) in porEspecie" :key="i" class="hover:bg-gray-100">
              <td class="border-t px-6 py-4">{{ e.especie }}</td>
              <td class="border-t px-6 py-4">{{ e.total }}</td>
              <td class="border-t px-6 py-4">
                {{ total > 0 ? ((e.total * 100) / total).toFixed(1) : '0.0' }}%
              </td>
            </tr>
            <tr v-if="porEspecie.length === 0">
              <td class="border-t px-6 py-4" colspan="3">Sin datos</td>
            </tr>
          </table>
        </div>
      </div>

      <!-- Por estado -->
      <div class="bg-white rounded-md shadow overflow-hidden">
        <div class="px-6 py-4 bg-gray-50 border-b border-gray-100 font-bold">
          Animales por estado
        </div>
        <div class="overflow-x-auto">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="px-6 pt-6 pb-4">Estado</th>
              <th class="px-6 pt-6 pb-4">Cantidad</th>
              <th class="px-6 pt-6 pb-4">% del total</th>
            </tr>
            <tr v-for="(s, i) in porEstado" :key="i" class="hover:bg-gray-100">
              <td class="border-t px-6 py-4">{{ s.estado }}</td>
              <td class="border-t px-6 py-4">{{ s.total }}</td>
              <td class="border-t px-6 py-4">
                {{ total > 0 ? ((s.total * 100) / total).toFixed(1) : '0.0' }}%
              </td>
            </tr>
            <tr v-if="porEstado.length === 0">
              <td class="border-t px-6 py-4" colspan="3">Sin datos</td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <!-- Botón volver -->
    <div class="mt-6">
      <inertia-link class="btn-indigo" :href="route('animales')">Ir a Animales</inertia-link>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'

export default {
  layout: Layout,
  props: {
    total: Number,
    porEspecie: Array,
    porEstado: Array,
  },
}
</script>